import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

import { markRfqRead } from '../../common/api/clients/rfq.api';
import { useRole } from '../../common/hooks/useRole';

interface UseMarkRfqReadParams {
    rfqId: string;
    supplierId?: string;
    supplierRead?: boolean;
}

export const useMarkRfqRead = ({ rfqId, supplierId, supplierRead }: UseMarkRfqReadParams) => {
    const role = useRole();
    const markRfqReadMutation = useMutation({ mutationFn: markRfqRead });

    useEffect(() => {
        if (supplierId && !supplierRead && role.isSupplier() && role.hasWriteRights(supplierId)) {
            markRfqReadMutation.mutate({
                rfqId,
                read: true,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rfqId, supplierId, supplierRead]);
};
